import { render, staticRenderFns } from "./RegisterProfile.vue?vue&type=template&id=f3c20bec&scoped=true"
import script from "./RegisterProfile.vue?vue&type=script&lang=js"
export * from "./RegisterProfile.vue?vue&type=script&lang=js"
import style0 from "./RegisterProfile.vue?vue&type=style&index=0&id=f3c20bec&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f3c20bec",
  null
  
)

export default component.exports